import {flare} from '@flareapp/js';

const IGNORED_MESSAGES = [
    'Request failed with status code 401',
    'Network Error',
    'Failed to fetch dynamically imported module',
    'is not a valid JavaScript MIME type',
    'Unable to preload CSS',
    'Request aborted',
    'Importing a module script failed.',
];

const IGNORED_USER_AGENTS = ['adsbot', 'googlebot'];

flare.beforeSubmit = (report) => {
    // Flare v2 dropped report.context in favour of OpenTelemetry-style attributes,
    // and made report.message optional. Reading the old shape threw inside the
    // error handler itself, which silently killed reporting.
    const message = report.message ?? '';

    if (IGNORED_MESSAGES.some((v) => message.includes(v))) {
        return false;
    }

    const userAgent = String(report.attributes?.['user_agent.original'] ?? '').toLowerCase();

    if (IGNORED_USER_AGENTS.some((v) => userAgent.includes(v))) {
        return false;
    }

    return report;
};

export default flare;
